import { BOT } from './types';

import * as InputsConverts from '../../components/views/chat/chatapp/messages/message/bot/ctrl_inputs';

export const BotMessages = {
    ConvertUserBotResponse: {
        toBotTextResponse: userBotResponse => {
            if (userBotResponse && userBotResponse.length > 0) {
                const botResponse = {
                    type: BOT.MESSAGE_TYPE.CONTROLS.TEXT,
                    value: ''
                };

                userBotResponse.forEach(message => {
                    if (message && message.type) {
                        switch (message.type) {
                            case BOT.MESSAGE_TYPE.CONTROLS.BUTTONS:
                                botResponse.value += message.value.text;
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTON_INPUTS:
                                botResponse.value +=
                                    message.value.buttonText + ': ' + message.value.inputValue;
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTONS:
                                botResponse.value += message.value.buttonText;
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.INPUTS:
                                botResponse.value += InputsConverts.botAnswerToText(message.value);
                                break;
                            default:
                                botResponse.value += -1;
                                break;
                        }
                    }
                });

                return botResponse;
            } else {
                return null;
            }
        },

        toBotResponses: userBotResponse => {
            if (userBotResponse && userBotResponse.length > 0) {
                const convertedMessages = [];
                let convertedMessage = {};

                userBotResponse.forEach(message => {
                    if (message && message.type) {
                        switch (message.type) {
                            case BOT.MESSAGE_TYPE.CONTROLS.BUTTONS:
                                convertedMessage = {
                                    value: message.value.id
                                };
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTON_INPUTS:
                                convertedMessage = {
                                    value: {
                                        id: message.value.buttonId,
                                        value: message.value.inputValue
                                    }
                                };
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTONS:
                                convertedMessage = {
                                    value: message.value.buttonId
                                };
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.INPUTS:
                                convertedMessage = InputsConverts.botAnswerToBotResponse(message);
                                break;
                            default:
                                convertedMessage = null;
                                break;
                        }

                        convertedMessage = {
                            ...convertedMessage,
                            type: message.type.replace('ctrl_', 'rslt_')
                        };

                        if (convertedMessage) {
                            convertedMessages.push(convertedMessage);
                        }
                    }
                });

                return convertedMessages;
            } else {
                return null;
            }
        },

        toTextResponse: userBotResponse => {
            const botMessage = BotMessages.ConvertUserBotResponse.toBotTextResponse(
                userBotResponse
            );

            if (botMessage && botMessage.value) {
                return botMessage.value;
            } else {
                return '';
            }
        }
    },

    ConvertBotResponse: {
        toText: botResponse => {
            if (botResponse && botResponse.length > 0) {
                let text = '';
                const separator = '.';
                const addSeparator = text => {
                    if (text.slice(-1) === separator) {
                        return text + ' ';
                    } else {
                        return text + separator + ' ';
                    }
                };
                botResponse
                    .filter(m => m && m.type)
                    .forEach(message => {
                        switch (message.type) {
                            case BOT.MESSAGE_TYPE.CONTROLS.TEXT:
                                text += addSeparator(message.value);
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.BUTTONS:
                            case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTON_INPUTS:
                                if (!message.value) {
                                    break;
                                }
                                text += 'Opcje: ';
                                message.value.forEach(button => {
                                    text += button.text + ', ';
                                });
                                text = addSeparator(text.substring(0, text.length - 2));
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTONS:
                                if (!message.value) {
                                    break;
                                }
                                text += 'Opcje: ';
                                message.value.forEach(radiobutton => {
                                    text += radiobutton.text + ', ';
                                });
                                text = addSeparator(text.substring(0, text.length - 2));
                                break;
                            case BOT.MESSAGE_TYPE.CONTROLS.INPUTS:
                                text = addSeparator(
                                    InputsConverts.botQuestionToText(message.value)
                                );
                                break;
                            default:
                                break;
                        }
                    });

                return text;
            } else {
                return null;
            }
        }
    }
};
